import { EXCLUSIVE } from './teamRequestsFilters.constants';

class TeamRequestsFiltersController {
  constructor($scope,EventEmitter) {
    'ngInject';
    this.$scope = $scope;
    this.EventEmitter = EventEmitter;
    this.name = 'teamRequestsFilters';
    this.selectedFilters = new Set([]);
  }

  _getResponseFilter(){
    let response = {
      selectedFilters: Array.from(this.selectedFilters)
    };
    return this.EventEmitter(response);
  }

  checkExclusiveFilters(filterName){
    if(this.exclusive === undefined){
      return;
    }

    if(EXCLUSIVE.ALL in this.exclusive && this.exclusive[EXCLUSIVE.ALL]){
      this.selectedFilters.clear();
    }
    if(filterName in this.exclusive){
      this.selectedFilters.delete(this.exclusive[filterName]);
    }
  }

  addFilter(filterName){
    this.checkExclusiveFilters(filterName);
    this.selectedFilters.add(filterName);
    this.onFilter(this._getResponseFilter());
  }

  removeFilter(filterName) {
    this.selectedFilters.delete(filterName);
    this.onFilter(this._getResponseFilter());
  }

  toogleFilter ( filterName){
    if (this.selectedFilters.has(filterName)){
      return this.removeFilter(filterName);
    }

    this.addFilter(filterName);
  }

  getCssActive(filterName) {
    return {
      'active': this.selectedFilters.has(filterName)
    };
  }

  getClassIcon(filter){
    if ('icon' in filter) { return filter.icon; }

    return filter.type;
  }

  hasFilters(){
    return this.selectedFilters.size > 0;
  }

  cleanFilters(){
    this.selectedFilters.clear();
    this.onFilter(this._getResponseFilter());
  }
}

export default TeamRequestsFiltersController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestsFilters/teamRequestsFilters.controller.js